
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsService } from 'app/services/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import { ApiService } from 'app/services/api';


@Component({
  templateUrl: './priorities.component.html',
  styleUrls: ['./priorities.component.css']
})
export class PrioritiesComponent implements OnInit {
  public form: FormGroup;
  public newForm: FormGroup;
  public forms: FormGroup;
  public Nomadform: FormGroup;
  public Insightform: FormGroup;
  public AmateurPopupform: FormGroup;
  public ProPopupform: FormGroup;

  public adminInsights
  public noMadFlow
  public rating
  public inviteFriend
  public nomadEnable
  public adminInsightEnable
  public isAmateurPopup
  public isProPopup

  public amateurPopupOrder
  public proPopupOrder
  display = "none";
  message;

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder, public formsService: FormsService,
    private fireDatabase: AngularFireDatabase, private apiService: ApiService) {

  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      adminInsights: parseInt(this.adminInsights),
      noMadFlow: parseInt(this.noMadFlow),
      inviteFriend: parseInt(this.inviteFriend),
      rating: parseInt(this.rating),
      amateurPopupOrder: parseInt(this.amateurPopupOrder),
      proPopupOrder: parseInt(this.proPopupOrder)
    });
    this.getCurrentVersions();
    this.newForm = this.formBuilder.group({
      inviteFriend: this.inviteFriend
    });
    this.getCurrentVersion()
    this.forms = this.formBuilder.group({
      rating: this.rating
    })
    this.Nomadform = this.formBuilder.group({
      nomadEnable: this.nomadEnable
    })
    this.Insightform = this.formBuilder.group({
      adminInsightEnable: this.adminInsightEnable
    })
    this.AmateurPopupform = this.formBuilder.group({
      amateurPopup: this.isAmateurPopup
    })
    this.ProPopupform = this.formBuilder.group({
      proPopup: this.isProPopup
    })

  }
  async getCurrentVersions() {
    try {
      let data = await this.apiService.list(`currentVersion/priority`)
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        if (data[i]["$key"] === "inviteFriend") {
          this.inviteFriend = data[i]["$value"];
        }
        if (data[i]["$key"] === "adminInsights") {
          this.adminInsights = data[i]["$value"];
        }
        if (data[i]["$key"] === "noMadFlow") {
          this.noMadFlow = data[i]["$value"];
        }
        if (data[i]["$key"] === "rating") {
          this.rating = data[i]["$value"];

        }
        if (data[i]["$key"] === "proPopupOrder") {
          this.proPopupOrder = data[i]["$value"];

        }
        if (data[i]["$key"] === "amateurPopupOrder") {
          this.amateurPopupOrder = data[i]["$value"];

        }
      }
      this.form = this.formBuilder.group({
        rating: this.rating,
        noMadFlow: this.noMadFlow,
        adminInsights: this.adminInsights,
        inviteFriend: this.inviteFriend,
        amateurPopupOrder: parseInt(this.amateurPopupOrder),
        proPopupOrder: parseInt(this.proPopupOrder)
      })
    }
    catch (error) {
    }
  }
  async submitPriority() {
    try {
      this.form.value.adminInsights = parseInt(this.form.value.adminInsights)
      this.form.value.noMadFlow = parseInt(this.form.value.noMadFlow)
      this.form.value.inviteFriend = parseInt(this.form.value.inviteFriend)
      this.form.value.rating = parseInt(this.form.value.rating)
      this.form.value.amateurPopupOrder = parseInt(this.form.value.amateurPopupOrder)

      this.form.value.proPopupOrder = parseInt(this.form.value.proPopupOrder)

      if ((this.form.value.adminInsights != this.form.value.noMadFlow) && (this.form.value.adminInsights != this.form.value.rating) && (this.form.value.adminInsights != this.form.value.inviteFriend) &&
        (this.form.value.noMadFlow != this.form.value.rating) && (this.form.value.noMadFlow != this.form.value.inviteFriend) && (this.form.value.rating != this.form.value.inviteFriend)) {
        let newdata = await this.apiService.update(`currentVersion/priority`, this.form.value)
        this.display = "block";
        this.message = "Priority added successfully..";
        this.getCurrentVersion()
      }
      else {
        this.display = "block";
        this.message = "Priorities are same please select different";
        this.getCurrentVersion()
      }
    }
    catch (error) {
    }
  }
  hidePop() {
    this.display = "none"
  }
  async isInvite() {
    try {
      if (this.newForm.value.inviteFriend == false) {
        this.newForm.value.inviteFriend = true
      }
      else if (this.newForm.value.inviteFriend == true) {
        this.newForm.value.inviteFriend = null
        let newdata = await this.apiService.set(`invite-friends/`, null)
      }
      // console.log(this.form.value);
      let newdata = await this.apiService.update(`currentVersion/`, this.newForm.value)
      // console.log(newdata);
    }
    catch (error) {
    }
  }
  async isRating() {
    try {
      if (this.forms.value.rating == false) {
        this.forms.value.rating = true
      }
      else if (this.forms.value.rating == true) {
        this.forms.value.rating = null
        let rating = await this.apiService.set(`user-ratings/`, null)
      }
      // console.log(this.form.value);
      let newdata = await this.apiService.update(`currentVersion/`, this.forms.value)

      // console.log(newdata);
    }
    catch (error) {
    }
  }
  async NoMad() {
    try {
      if (this.Nomadform.value.nomadEnable == false) {
        this.Nomadform.value.nomadEnable = true
      }
      else if (this.Nomadform.value.nomadEnable == true) {
        this.Nomadform.value.nomadEnable = null
      }
      console.log(this.form.value);
      let newdata = await this.apiService.update(`currentVersion/`, this.Nomadform.value)

      console.log(newdata);
    }
    catch (error) {
    }
  }
  async adminInsight() {
    try {
      if (this.Insightform.value.adminInsightEnable == false) {
        this.Insightform.value.adminInsightEnable = true
      }
      else if (this.Insightform.value.adminInsightEnable == true) {
        this.Insightform.value.adminInsightEnable = null
      }
      // console.log(this.form.value);
      let newdata = await this.apiService.update(`currentVersion/`, this.Insightform.value)

      // console.log(newdata);
    }
    catch (error) {
    }
  }
  async onAmatuerPopup() {
    try {
      if (this.AmateurPopupform.value.amateurPopup == false) {
        this.AmateurPopupform.value.amateurPopup = true
      }
      else if (this.AmateurPopupform.value.amateurPopup == true) {
        this.AmateurPopupform.value.amateurPopup = null
      }
      // console.log(this.form.value);
      let newdata = await this.apiService.update(`currentVersion/`, this.AmateurPopupform.value)

      // console.log(newdata);
    }
    catch (error) {
    }
  }
  async onProPopup() {
    console.log(this.ProPopupform.value);

    try {
      if (this.ProPopupform.value.proPopup == false) {
        this.ProPopupform.value.proPopup = true
      }
      else if (this.ProPopupform.value.proPopup == true) {
        this.ProPopupform.value.proPopup = null
      }
      let newdata = await this.apiService.update(`currentVersion/`, this.ProPopupform.value)

      // console.log(newdata);
    }
    catch (error) {
      console.log(error);

    }
  }
  async getCurrentVersion() {
    try {
      let data = await this.apiService.list(`currentVersion`)
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        if (data[i]["$key"] === "inviteFriend") {
          this.inviteFriend = data[i]["$value"];
          this.newForm = this.formBuilder.group({
            inviteFriend: this.inviteFriend,
          })
        }
        if (data[i]["$key"] === "rating") {
          this.rating = data[i]["$value"];
          this.forms = this.formBuilder.group({
            rating: this.rating,
          })
        }
        if (data[i]["$key"] === "nomadEnable") {
          this.nomadEnable = data[i]["$value"];
          this.Nomadform = this.formBuilder.group({
            nomadEnable: this.nomadEnable,
          })
        }
        if (data[i]["$key"] === "adminInsightEnable") {
          this.adminInsightEnable = data[i]["$value"];
          this.Insightform = this.formBuilder.group({
            adminInsightEnable: this.adminInsightEnable,
          })
        }
        if (data[i]["$key"] === "amateurPopup") {
          this.isAmateurPopup = data[i]["$value"];
          this.AmateurPopupform = this.formBuilder.group({
            amateurPopup: this.isAmateurPopup,
          })
        }
        if (data[i]["$key"] === "proPopup") {
          this.isProPopup = data[i]["$value"];
          this.ProPopupform = this.formBuilder.group({
            proPopup: this.isProPopup,
          })
        }
      }
    }
    catch (error) {
    }
  }
}



